export  class ResponseValueObject<T> {
  constructor(
    public readonly success: boolean,
    public readonly data?: T,
    public readonly message?: string,
    public readonly errors: string[] = [] // Inicializado como array vacío por defecto
  ) {} // Se agregaron las llaves del cuerpo
}
